// Copyright (c) Docugami, Inc. All rights reserved.

import { MessageBusSingleton } from "messaging/MessageBus";
import { IMessage } from "messaging/MessageTypes";
import { useCallback } from "react";

export interface IMessagePublisher {
    sendMessage: (message: IMessage) => void
    sendCommand: (message: IMessage) => boolean
};

/**
 * Used to publish messages or commands to the global MessageBus
 */
export const useMessagePublisher = () => {
    const sendMessage = useCallback((message: IMessage) => {
        MessageBusSingleton.sendMessage(message);
    }, []);

    const sendCommand = useCallback((message: IMessage, required: boolean = false): boolean => {
        return MessageBusSingleton.sendCommand(message, required);
    }, []);

    return {
        sendMessage: sendMessage,
        sendCommand: sendCommand
    }
}
